module.exports = __webpack_public_path__ + "static/media/samsung_light.3fcb627f.png";